import React, { useContext, useEffect, useState } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import {toast} from "react-toastify";
import moment from "moment/moment";

const CampaignView = ({

    match,
    documentUploadUrlPublic,
    documentUrlDataPublic,
    history,
    approvedResponse=[],
    getCampaignData,
    getCampaignListing=[]
                         }) => {
    const [isLoading, setIsLoading] = useState(false);
 

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getCampaignData(1, null, null, match?.params?.campaign_id);
            setIsLoading(false);
        })();
    }, []);

    return (
        <>
            <Layout title={localization.campaignDetailView} isLoading={isLoading} isGoback={true}>
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.detailView}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <DivLayout 
                                heading={"Campaign Type"} 
                                data={getCampaignListing[0]?.campaign_type} 
                            />
                            {getCampaignListing[0]?.campaign_type !== null &&( 
                                <DivLayout 
                                    heading={"Campaign Subtype"} 
                                    data={getCampaignListing[0]?.campaign_subtype} 
                                />
                            )}

                            {getCampaignListing[0]?.user_segment !== null &&(
                                <DivLayout 
                                    heading={"User Segment"} 
                                    data={getCampaignListing[0]?.user_segment} 
                                />
                            )}
                            <DivLayout
                                heading={"Start Date"}
                                data={getCampaignListing[0]?.start_date}
                            />
                            {getCampaignListing[0]?.end_date !== null &&( 
                                <DivLayout
                                    heading={"End Date"}
                                    data={getCampaignListing[0]?.end_date}
                                />
                            )}

                            {getCampaignListing[0]?.carnival_date !== null &&( 
                                <DivLayout
                                    heading={"Carnival Date"}
                                    data={getCampaignListing[0]?.carnival_date}
                                />
                            )}

                            {getCampaignListing[0]?.invoice_number !== null &&( 
                                <DivLayout
                                    heading={"Invoice Number"}
                                    data={getCampaignListing[0]?.invoice_number}
                                />
                            )}

                            {getCampaignListing[0]?.pid_number !== null &&( 
                                <DivLayout
                                    heading={"PID Number"}
                                    data={getCampaignListing[0]?.pid_number}
                                />
                            )}
                            {getCampaignListing[0]?.pid_name !== null &&( 
                                <DivLayout
                                    heading={"PID Name"}
                                    data={getCampaignListing[0]?.pid_name}
                                />
                            )}
                            {getCampaignListing[0]?.vendor_name !== null &&( 
                                <DivLayout
                                    heading={"Vendor Name"}
                                    data={getCampaignListing[0]?.vendor_name}
                                />
                            )}
                            {getCampaignListing[0]?.poc_details['name'] !== null &&( 
                                <DivLayout
                                    heading={"POC Name"}
                                    data={getCampaignListing[0]?.poc_details['name']}
                                />
                            )}
                            {getCampaignListing[0]?.poc_details['mail'] !== null &&( 
                                <DivLayout
                                    heading={"POC Email"}
                                    data={getCampaignListing[0]?.poc_details['mail']}
                                />
                            )}
                            {getCampaignListing[0]?.poc_details['mobile_number'] !== null &&( 
                                <DivLayout
                                    heading={"POC Mobile Number"}
                                    data={getCampaignListing[0]?.poc_details['mobile_number']}
                                />
                            )}
                            {getCampaignListing[0]?.user_remarks !== null &&( 
                                <DivLayout
                                    heading={"User Remarks"}
                                    data={getCampaignListing[0]?.user_remarks}
                                />
                            )}
                            {getCampaignListing[0]?.revenue_impression !== null &&( 
                                <DivLayout
                                    heading={"Revenue Impression Revenue"}
                                    data={getCampaignListing[0]?.revenue_impression}
                                />
                            )}
                            {getCampaignListing[0]?.revenue_lead_based !== null &&( 
                                <DivLayout
                                    heading={"Revenue Lead Based Revenue"}
                                    data={getCampaignListing[0]?.revenue_lead_based}
                                />
                            )}

                            {getCampaignListing[0]?.revenue_install !== null &&( 
                                <DivLayout
                                    heading={"Revenue Install Revenue"}
                                    data={getCampaignListing[0]?.revenue_install}
                                />
                            )}

                            {getCampaignListing[0]?.revenue_ctr !== null &&( 
                                <DivLayout
                                    heading={"CTR Revenue"}
                                    data={getCampaignListing[0]?.revenue_ctr}
                                />
                            )}

                            {getCampaignListing[0]?.revenue_lead_conversion !== null &&( 
                                <DivLayout
                                    heading={"Lead Conversion Revenue"} 
                                    data={getCampaignListing[0]?.revenue_lead_conversion}
                                />
                            )}

                            {getCampaignListing[0]?.status_name !== null &&( 
                                <DivLayout
                                    heading={"Status"} 
                                    data={getCampaignListing[0]?.status_name}
                                />
                            )}

                            {getCampaignListing[0]?.name !== null &&( 
                                <DivLayout
                                    heading={"Created By"} 
                                    data={getCampaignListing[0]?.name}
                                />
                            )}

                            {getCampaignListing[0]?.name !== null &&( 
                                <DivLayout
                                    heading={"Created By Email"} 
                                    data={getCampaignListing[0]?.email}
                                />
                            )}

                            {getCampaignListing[0]?.created_at !== null && (
                                <DivLayout
                                    heading={"Created At"} 
                                    data={new Date(getCampaignListing[0]?.created_at).toLocaleString('en-US', {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                />
                            )}


                        </div>
                    </div>
                </div>

                    {/* <div className="panel-card card-details" style={{ width: "100%" }}>
                        <div className="panel-heading">
                            {localization.attachment}
                        </div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <div className="row">
                                    {getCampaignListing.attachment && getCampaignListing?.attachment.map((val) => {
                                        return (
                                            <>
                                            {console.log("Test val:", val)}
                                                {val!== "" && val !== null && (
                                                    <div className="col-md-4">
                                                        <DocumentView
                                                            title={localization.attachment}
                                                            attachment={val}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* {console.log("test new:", getCampaignListing[0]?.attachment)} */}
                {getCampaignListing[0]?.attachment !== undefined && getCampaignListing[0]?.attachment !== null &&
                    getCampaignListing[0]?.attachment[0] !== undefined &&
                    getCampaignListing[0]?.attachment[0] !== null && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {"PO/MOU of the deal"}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {getCampaignListing[0]?.attachment.map((val) => {
                                            return (
                                                <>
                                                    {val!== "" && val !== null && (
                                                        <div className="col-md-4">
                                                            <DocumentView
                                                                title={localization.attachment}
                                                                attachment={val}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

            </Layout>
        </>
    );
};

export default CampaignView;
